import { request } from '../utils/http'

const buildQuery = (params = {}) => {
  const usp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      usp.append(key, value)
    }
  })
  const str = usp.toString()
  return str ? `?${str}` : ''
}

export const uploadPhotoMedia = (file) => {
  const formData = new FormData()
  formData.append('file', file)

  return request('/api/photo/upload', {
    method: 'POST',
    body: formData,
    showSuccessMessage: false
  })
}

export const getPhotoPage = (params = {}) => {
  const { pageNum = 1, pageSize = 20, location, month, mood, startDate, endDate, keyword } = params
  return request(`/api/photo/page${buildQuery({ pageNum, pageSize, location, month, mood, startDate, endDate, keyword })}`)
}

export const getPhotoDetail = (id) => request(`/api/photo/${id}`)

export const getPhotoTags = () => request('/api/photo/tags')

export const getAlbumTags = () => request('/api/album/tags')

export const createPhoto = (payload) => request('/api/photo', {
  method: 'POST',
  body: payload
})

export const updatePhoto = (id, payload) => request(`/api/photo/${id}`, {
  method: 'PUT',
  body: payload
})

export const deletePhoto = (id) => request(`/api/photo/${id}`, {
  method: 'DELETE'
})

export const getVisitorPhotos = (params = {}) => {
  const { pageNum = 1, pageSize = 20 } = params
  return request(`/api/visitor/photos${buildQuery({ pageNum, pageSize })}`, { auth: false })
}
